// extracted by mini-css-extract-plugin
export default {"container":"container-gIyvNpOO","bankIcon":"bankIcon-xOrZupwt"};